import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('ls-systems-button')
export class LsSystemsButton extends LitElement {
    static styles = css`
        a {
            display: block;
            text-decoration: none;
            font-weight: 500;
            font-size: 14px;
            padding: 10px 15px;
            line-height: 20px;
            border-radius: 5px;
            color: #333;
            text-wrap: nowrap;
            text-align: left;
            user-select: none;
        }

        :host([theme='secondary']) a.active,
        :host([theme='secondary']) a:hover {
            background-color: #ffffff;
        }

        a.active,
        a:hover {
            color: #333;
            background-color: #00adee1a;
            box-shadow:
                inset 0 1px 0 #ffffff,
                inset 0 -1px 0 #dcdfe4;
        }

        a.active {
            cursor: default;
            pointer-events: none;
        }
    `;

    @property({ type: Boolean }) active: boolean = false;
    @property({ type: String }) name: string = '';
    @property({ type: String }) uri: string = '';
    @property({ type: String }) theme: 'primary' | 'secondary' = 'primary';
    @property({ type: String }) target: '_self' | '_blank' | '_parent' | '_top' = '_self';

    render() {
        return html`<a class="${this.active && 'active'}" href=${this.uri} target=${this.target}> ${this.name} </a>
            <slot></slot>`;
    }
}
